var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "create-voucher bg-white rounded-lg shadow-sm p-6 mb-10"
  }, [_vm._m(0), _c('div', {
    staticClass: "grid grid-cols-1 md:grid-cols-2 gap-6"
  }, [_c('div', {
    staticClass: "col-span-1"
  }, [_c('label', {
    staticClass: "block text-sm font-medium text-neutral-700 mb-2"
  }, [_vm._v("Nama Voucher")]), _c('TextField', {
    attrs: {
      "placeholder": "Masukkan nama voucher"
    },
    model: {
      value: _vm.form.name,
      callback: function ($$v) {
        _vm.$set(_vm.form, "name", $$v);
      },
      expression: "form.name"
    }
  })], 1), _c('div', {
    staticClass: "col-span-1"
  }, [_c('label', {
    staticClass: "block text-sm font-medium text-neutral-700 mb-2"
  }, [_vm._v("Kode Voucher")]), _c('TextField', {
    attrs: {
      "placeholder": "ex: ONGKIR10"
    },
    model: {
      value: _vm.form.voucher_code,
      callback: function ($$v) {
        _vm.$set(_vm.form, "voucher_code", $$v);
      },
      expression: "form.voucher_code"
    }
  })], 1), _c('div', {
    staticClass: "md:col-span-2"
  }, [_c('label', {
    staticClass: "block text-sm font-medium text-neutral-700 mb-2"
  }, [_vm._v(" Deskripsi ")]), _c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: _vm.form.description,
      expression: "form.description"
    }],
    staticClass: "w-full rounded-lg border border-neutral-300 px-3 py-2 text-sm focus:outline-none focus:ring-2 focus:ring-primary-500 resize-none",
    attrs: {
      "rows": "4",
      "maxlength": "500",
      "placeholder": "Masukkan deskripsi voucher..."
    },
    domProps: {
      "value": _vm.form.description
    },
    on: {
      "input": function ($event) {
        if ($event.target.composing) return;

        _vm.$set(_vm.form, "description", $event.target.value);
      }
    }
  }), _c('p', {
    staticClass: "mt-1 text-xs text-neutral-500"
  }, [_vm._v(" Maksimal 4 baris / 500 karakter ")])]), _c('div', {
    staticClass: "md:col-span-2"
  }, [_c('label', {
    staticClass: "block text-sm font-medium text-neutral-700 mb-2"
  }, [_vm._v("Gambar Voucher")]), _c('div', {
    staticClass: "border-2 border-dashed rounded-lg p-4 text-center cursor-pointer hover:bg-gray-50 transition",
    on: {
      "click": function ($event) {
        return _vm.$refs.imageInput.click();
      }
    }
  }, [_c('input', {
    ref: "imageInput",
    staticClass: "hidden",
    attrs: {
      "type": "file",
      "accept": "image/*"
    },
    on: {
      "change": _vm.onImageChange
    }
  }), _vm.imagePreview ? _c('div', {
    staticClass: "flex justify-center"
  }, [_c('img', {
    staticClass: "max-h-40 rounded-md",
    attrs: {
      "src": _vm.imagePreview,
      "alt": "Preview"
    }
  })]) : _c('div', {
    staticClass: "py-4 text-sm text-gray-500"
  }, [_vm._v(" Klik untuk upload gambar (PNG/JPG, max 10MB) ")])])]), _c('div', {
    staticClass: "col-span-1"
  }, [_vm._m(1), _c('CustomSelect', {
    attrs: {
      "options": _vm.deliveryServices,
      "default": _vm.selectedDeliveryService,
      "optionLabel": "name",
      "placeholder": "Pilih layanan pengiriman"
    },
    on: {
      "input": function (val) {
        return _vm.selectedDeliveryService = val;
      },
      "change": _vm.onDeliveryServiceChange
    }
  })], 1), _c('div', {
    staticClass: "col-span-1"
  }, [_vm._m(2), _c('v-select', {
    staticClass: "style-chooser",
    attrs: {
      "multiple": "",
      "options": _vm.packageList,
      "label": "name",
      "placeholder": "Pilih service/paket"
    },
    model: {
      value: _vm.selectedPackages,
      callback: function ($$v) {
        _vm.selectedPackages = $$v;
      },
      expression: "selectedPackages"
    }
  })], 1), _c('div', {
    staticClass: "col-span-1"
  }, [_c('label', {
    staticClass: "block text-sm font-medium text-neutral-700 mb-2"
  }, [_vm._v("Periode Voucher")]), _c('date-range-picker', {
    staticClass: "w-full clean-daterange-picker",
    attrs: {
      "locale-data": {
        format: 'dd/mm/yyyy HH:MM',
        separator: ' - '
      },
      "timePicker": true,
      "timePicker24Hour": true,
      "showDropdowns": true,
      "ranges": false
    },
    scopedSlots: _vm._u([{
      key: "input",
      fn: function (picker) {
        return [_c('div', {
          staticClass: "w-full flex justify-between items-center rounded-lg border border-neutral-300 px-3 py-4 bg-white cursor-pointer"
        }, [_c('span', {
          staticClass: "text-sm text-neutral-700"
        }, [_vm._v(" " + _vm._s(_vm._f("date")(picker.startDate)) + " - " + _vm._s(_vm._f("date")(picker.endDate)) + " ")]), _c('Calendar')], 1)];
      }
    }]),
    model: {
      value: _vm.dateRange,
      callback: function ($$v) {
        _vm.dateRange = $$v;
      },
      expression: "dateRange"
    }
  })], 1), _c('div', {
    staticClass: "col-span-1"
  }, [_c('label', {
    staticClass: "block text-sm font-medium text-neutral-700 mb-2"
  }, [_vm._v("Diskon (%)")]), _c('TextField', {
    attrs: {
      "type": "number",
      "placeholder": "ex: 10"
    },
    model: {
      value: _vm.form.discount_percentage,
      callback: function ($$v) {
        _vm.$set(_vm.form, "discount_percentage", $$v);
      },
      expression: "form.discount_percentage"
    }
  })], 1), _c('div', {
    staticClass: "col-span-1"
  }, [_c('label', {
    staticClass: "block text-sm font-medium text-neutral-700 mb-2"
  }, [_vm._v("Maks Nominal Diskon")]), _c('TextField', {
    attrs: {
      "type": "number",
      "placeholder": "ex: 5000"
    },
    model: {
      value: _vm.form.max_discount_amount,
      callback: function ($$v) {
        _vm.$set(_vm.form, "max_discount_amount", $$v);
      },
      expression: "form.max_discount_amount"
    }
  })], 1), _c('div', {
    staticClass: "col-span-1"
  }, [_c('label', {
    staticClass: "block text-sm font-medium text-neutral-700 mb-2"
  }, [_vm._v("Kuota")]), _c('TextField', {
    attrs: {
      "type": "number",
      "placeholder": "ex: 100"
    },
    model: {
      value: _vm.form.quota,
      callback: function ($$v) {
        _vm.$set(_vm.form, "quota", $$v);
      },
      expression: "form.quota"
    }
  })], 1), _c('div', {
    staticClass: "col-span-1"
  }, [_c('label', {
    staticClass: "block text-sm font-medium text-neutral-700 mb-2"
  }, [_vm._v(" Status ")]), _c('div', {
    staticClass: "flex items-center gap-3"
  }, [_c('Toggle', {
    attrs: {
      "id": "voucher-status-toggle"
    },
    model: {
      value: _vm.statusActive,
      callback: function ($$v) {
        _vm.statusActive = $$v;
      },
      expression: "statusActive"
    }
  }), _c('span', {
    staticClass: "text-sm font-medium"
  }, [_vm._v(" " + _vm._s(_vm.statusActive ? "Active" : "Inactive") + " ")])], 1)])]), _c('div', {
    staticClass: "mt-8 flex justify-end gap-3"
  }, [_c('button', {
    staticClass: "px-4 py-2 rounded-lg border border-neutral-300 text-neutral-600 hover:bg-neutral-50 font-medium transition",
    on: {
      "click": function ($event) {
        return _vm.$router.push('/voucher');
      }
    }
  }, [_vm._v(" Batal ")]), _c('button', {
    staticClass: "px-4 py-2 rounded-lg bg-primary-500 text-white hover:bg-primary-600 font-medium disabled:opacity-50 transition",
    attrs: {
      "disabled": _vm.loading
    },
    on: {
      "click": _vm.submit
    }
  }, [_vm._v(" " + _vm._s(_vm.loading ? "Menyimpan..." : "Simpan Voucher") + " ")])])]);

}
var staticRenderFns = [function (){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "mb-6"
  }, [_c('h1', {
    staticClass: "text-xl font-bold text-neutral-700"
  }, [_vm._v("Buat Voucher Baru")])]);

},function (){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('label', {
    staticClass: "block text-sm font-medium text-neutral-700 mb-2"
  }, [_vm._v("Layanan Pengiriman "), _c('span', {
    staticClass: "text-gray-400"
  }, [_vm._v("(Opsional)")])]);

},function (){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('label', {
    staticClass: "block text-sm font-medium text-neutral-700 mb-2"
  }, [_vm._v("Service / Paket "), _c('span', {
    staticClass: "text-gray-400"
  }, [_vm._v("(Opsional)")])]);

}]

export { render, staticRenderFns }